var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":_vm.id}},_vm._l((_vm.rows),function(r,index){return _c('div',{key:r.id,staticClass:"ui segment"},[_c(r.type,{tag:"component",attrs:{"id":r.id}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }